//Global service for global variables
function ctrl($location, $q, $window) {
    return function (namespace) {
        let defer = $q.defer();
        let socket = io.connect(api+namespace, {
            secure: true,
            query: 'token=' + $window.sessionStorage.token,
            forceNew: true
        });
        defer.resolve(socket);
        return defer.promise;
    }
}

ctrl.$inject = ['$location', '$q', '$window'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/system/services/socket.js
 **/